export const DAY_TERM = 'day';
export const ANNUAL_TERM = 'year';
export const MONTH_TERM = 'month';
export const CHECKBOX_TYPE = 'checkbox';
export const SINGLE_LINE_TYPE = 'input';
export const TEXT_TYPE = 'text';
export const RADIO_TYPE = 'dropdown';
export const DROPDOWN_TYPE = 'radio';
export const FILE_TYPE = 'file';
export const CAPACITY_TYPE = { product: 0, variants: 1, resources: 2 };
export const PRODUCT_PROFILE = 'product';
export const ACTIVITY_PROFILE = 'activity';
export const COURSE_PROFILE = 'course';
export const RENTAL_PROFILE = 'rental';
export const CLASS_PROFILE = 'class';
export const APPT_PROFILE = 'appt';
export const ROOM_PROFILE = 'room';
export const DEPOSIT_PROFILE = 'deposit';
export const SECURITY_BOND_PROFILE = 'bond';
export const GENERAL_PROFILE = '';
export const PLACEHOLDER_PHONE = 'e.g +1 555 555 5555';
export const DURATION_TYPE = { product: 0, variant: 1 };